import { useState, useCallback } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import InstructionDeletion from "../../components/InstructionDeletion";
import PortalPopup from "../../components/PortalPopup";
import FileDeletion from "../../components/FileDeletion";
import LogoutConfirmation from "../../components/LogoutConfirmation";
import NavigationPanelLawyer from "../../components/NavigationPanelLawyer";
import Breadcrumb from "../../components/Breadcrumb";
import CTAs from "../../components/CTAs";
import Upload from "../../components/Upload";
import Footer from "../../components/Footer";

const CDI_3 = ({ onClose }) => {
  const navigate = useNavigate();
  const [isInstructionDeletionOpen, setInstructionDeletionOpen] =
    useState(false);
  const [isFileDeletionOpen, setFileDeletionOpen] = useState(false);
  const [isFileDeletion1Open, setFileDeletion1Open] = useState(false);
  const [isFileDeletion2Open, setFileDeletion2Open] = useState(false);
  const [isFileDeletion3Open, setFileDeletion3Open] = useState(false);
  const [isLogoutConfirmationOpen, setLogoutConfirmationOpen] = useState(false);

  const openInstructionDeletion = useCallback(() => {
    setInstructionDeletionOpen(true);
  }, []);

  const closeInstructionDeletion = useCallback(() => {
    setInstructionDeletionOpen(false);
  }, []);

  const openFileDeletion = useCallback(() => {
    setFileDeletionOpen(true);
  }, []);

  const closeFileDeletion = useCallback(() => {
    setFileDeletionOpen(false);
  }, []);

  const openFileDeletion1 = useCallback(() => {
    setFileDeletion1Open(true);
  }, []);

  const closeFileDeletion1 = useCallback(() => {
    setFileDeletion1Open(false);
  }, []);

  const openFileDeletion2 = useCallback(() => {
    setFileDeletion2Open(true);
  }, []);

  const closeFileDeletion2 = useCallback(() => {
    setFileDeletion2Open(false);
  }, []);

  const openFileDeletion3 = useCallback(() => {
    setFileDeletion3Open(true);
  }, []);

  const closeFileDeletion3 = useCallback(() => {
    setFileDeletion3Open(false);
  }, []);

  const closeLogoutConfirmation = useCallback(() => {
    setLogoutConfirmationOpen(false);
  }, []);

  const navItems = [
    {
      text: "Dashboard",
      bgColor: "bg-neutrals-neutral-50",
      textColor: "text-neutrals-neutral-300",
      hoverBgColor: "bg-neutrals-neutral-50",
      hoverTextColor: "text-primary-primary-500",
      path: "/dashboard",
    },
    {
      text: "Legal proceedings & billing",
      bgColor: "bg-neutrals-neutral-50",
      textColor: "text-neutrals-neutral-300",
      hoverBgColor: "bg-neutrals-neutral-50",
      hoverTextColor: "text-primary-primary-500",
      path: "/legal_1",
    },
    {
      text: "Pre-LBA checks",
      bgColor: "bg-neutrals-neutral-50",
      textColor: "text-neutrals-neutral-300",
      hoverBgColor: "bg-neutrals-neutral-50",
      hoverTextColor: "text-primary-primary-500",
      path: "/prelbacheck",
    },
    {
      text: "Client-debtor interaction",
      bgColor: "bg-primary-primary-50",
      textColor: "text-neutrals-neutral-900",
      hoverBgColor: "bg-primary-primary-50",
      hoverTextColor: "text-neutrals-neutral-900",
      path: "",
    },
  ];

  const breadcrumb = [
    { label: "", path: "", icon: "assets/home.svg", active: true },
    { label: "Client instructions", path: "/cdi1", icon: "", active: false },
    { label: "Review payment history", path: "", icon: "", active: true },
  ];

  return (
    <>
      <div className="w-full relative bg-neutrals-neutral-50 min-h-screen overflow-visible text-left text-sm text-neutrals-neutral-300 font-open-sans-ff-body-strong">
        {/* Navigation Panel */}
        <NavigationPanelLawyer navItems={navItems} />

        {/* Main */}
        <div className="w-full absolute top-[136px] flex flex-col items-start justify-start gap-6 text-neutrals-neutral-900 px-4 md:px-4 lg:px-24 box-border">
          <div className="w-full flex flex-col items-start justify-start gap-1">
            <b className="self-stretch relative text-9xl">
              Client-debtor interaction
            </b>
            <div className="self-stretch relative text-base text-neutrals-neutral-300">{`Get all your information for client & debtor over here.`}</div>
          </div>

          {/* Breadcrumb Navigation */}
          <Breadcrumb breadcrumbs={breadcrumb} />

          <div className="self-stretch flex flex-col items-start justify-start gap-8 text-base">
            {/* Card */}
            <div className="shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-3xs bg-white border-neutrals-neutral-100 border-solid border-[1px] flex flex-col items-start justify-start">
              <div className="w-[400px] rounded-t-3xs rounded-b-none bg-white  box-border flex flex-col items-start justify-start p-6 gap-6">
                <div className="self-stretch flex flex-row items-start justify-between gap-0">
                  <div className="flex-1 flex flex-col items-start justify-start gap-2.5">
                    <div className="self-stretch relative font-semibold">
                      Review payment history
                    </div>
                    <div className="self-stretch relative text-neutrals-neutral-300">
                      Review debtor's recent payment history and provide
                      recommendations.
                    </div>
                  </div>
                  <div className="rounded-[20px] bg-semantics-moderate-moderate-50 border-semantics-moderate-moderate-500 border-solid border-[1px] flex flex-row items-center justify-start py-0.5 px-2 gap-1.5 text-sm text-semantics-moderate-moderate-500">
                    <div className="w-1.5 relative rounded-[50%] bg-semantics-moderate-moderate-500 h-1.5" />
                    <div className="relative font-semibold">Pending</div>
                  </div>
                </div>
                <div className="self-stretch flex flex-col items-start justify-start gap-2.5 text-neutrals-neutral-300">
                  <div className="flex flex-row items-center justify-start gap-1.5">
                    <img
                      className="w-5 relative h-5"
                      alt=""
                      src="assets/calendar.svg"
                    />
                    <div className="relative">02/02/24</div>
                  </div>
                  <div className="rounded-[5px] bg-white border-neutrals-neutral-100 border-solid border-[1px] flex flex-row items-center justify-start py-0.5 px-2 gap-1.5 text-sm text-neutrals-neutral-900">
                    <div className="w-1.5 relative rounded-[50%] bg-semantics-high-high-500 h-1.5" />
                    <div className="relative font-semibold">High</div>
                  </div>
                </div>
              </div>
              <div className="w-[400px] border-neutrals-neutral-100 border-solid border-t-[1px] box-border flex flex-col items-end justify-start py-4 px-6 text-sm">
                <div className="flex flex-row items-start justify-end gap-[10px]">
                  <CTAs
                    type="Ghostbtn"
                    text="Delete"
                    textColor="text-neutrals-neutral-900"
                    bgColor="bg-neutrals-neutral-50"
                    borderColor="border-neutrals-neutral-100"
                    position="relative"
                    onClick={openInstructionDeletion}
                  />

                  <CTAs
                    type="Ghostbtn"
                    text="Mark as complete"
                    textColor="text-neutrals-neutral-900"
                    bgColor="bg-neutrals-neutral-50"
                    borderColor="border-neutrals-neutral-100"
                    position="relative"
                  />
                </div>
              </div>
            </div>

            {/* Attached documents */}
            <div className="self-stretch flex flex-col items-start justify-start gap-6 text-lg">
              <div className="w-full border-neutrals-neutral-100 border-solid border-b-[1px] box-border flex flex-col items-start justify-start pt-0 px-0 pb-6">
                <div className="self-stretch flex flex-row items-start justify-between gap-0">
                  <div className="flex flex-col items-start justify-start gap-1.5">
                    <div className="relative font-semibold">
                      Attached documents
                    </div>
                    <div className="relative text-base text-neutrals-neutral-300">
                      List of all attached documents.
                    </div>
                  </div>
                  <div className="flex flex-row items-start justify-end gap-[10px] text-sm">
                    <CTAs
                      type="Ghostbtn"
                      text="Delete all"
                      textColor="text-neutrals-neutral-900"
                      bgColor="bg-neutrals-neutral-50"
                      borderColor="border-neutrals-neutral-100"
                      position="relative"
                      icon="assets/delete.svg"
                      onClick={openFileDeletion}
                    />

                    <CTAs
                      type="Ghostbtn"
                      text="Download all"
                      textColor="text-neutrals-neutral-900"
                      bgColor="bg-neutrals-neutral-50"
                      borderColor="border-neutrals-neutral-100"
                      position="relative"
                      icon="assets/download.svg"
                    />
                  </div>
                </div>
              </div>
              {/* Invoives */}
              <div className="w-full flex flex-row items-start justify-start flex-wrap content-start gap-6 text-base">
                {/* Card 1 */}
                <div className="w-[400px] shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-3xs bg-white border-neutrals-neutral-100 border-solid border-[1px] box-border flex flex-col items-start justify-start">
                  <div className="self-stretch flex flex-row items-start justify-between p-6 gap-0">
                    <div className="flex flex-col items-start justify-start gap-2.5">
                      <img
                        className="w-10 relative h-10"
                        alt=""
                        src="assets/pdf.svg"
                      />
                      <div className="relative font-semibold">Invoice.pdf</div>
                      <div className="relative text-neutrals-neutral-300">
                        1.2MB
                      </div>
                    </div>
                    <div className="relative text-neutrals-neutral-300">
                      29/01/24
                    </div>
                  </div>
                  <div className="self-stretch border-neutrals-neutral-100 border-solid border-t-[1px] flex flex-col items-end justify-start py-4 px-6 text-sm">
                    <div className="flex flex-row items-start justify-end gap-[10px]">
                      <CTAs
                        type="Ghostbtn"
                        text="Delete"
                        textColor="text-neutrals-neutral-900"
                        bgColor="bg-neutrals-neutral-50"
                        borderColor="border-neutrals-neutral-100"
                        position="relative"
                        icon="assets/delete.svg"
                        onClick={openFileDeletion1}
                      />

                      <CTAs
                        type="Ghostbtn"
                        text="Download"
                        textColor="text-neutrals-neutral-900"
                        bgColor="bg-neutrals-neutral-50"
                        borderColor="border-neutrals-neutral-100"
                        position="relative"
                        icon="assets/download.svg"
                      />
                    </div>
                  </div>
                </div>
                {/* Card 2 */}
                <div className="w-[400px] shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-3xs bg-white border-neutrals-neutral-100 border-solid border-[1px] box-border flex flex-col items-start justify-start">
                  <div className="self-stretch flex flex-row items-start justify-between p-6 gap-0">
                    <div className="flex flex-col items-start justify-start gap-2.5">
                      <img
                        className="w-10 relative h-10"
                        alt=""
                        src="assets/word_file.svg"
                      />
                      <div className="relative font-semibold">
                        Contract.docx
                      </div>
                      <div className="relative text-neutrals-neutral-300">
                        24KB
                      </div>
                    </div>
                    <div className="relative text-neutrals-neutral-300">
                      29/01/24
                    </div>
                  </div>
                  <div className="self-stretch border-neutrals-neutral-100 border-solid border-t-[1px] flex flex-col items-end justify-start py-4 px-6 text-sm">
                    <div className="flex flex-row items-start justify-end gap-[10px]">
                      <CTAs
                        type="Ghostbtn"
                        text="Delete"
                        textColor="text-neutrals-neutral-900"
                        bgColor="bg-neutrals-neutral-50"
                        borderColor="border-neutrals-neutral-100"
                        position="relative"
                        icon="assets/delete.svg"
                        onClick={openFileDeletion1}
                      />

                      <CTAs
                        type="Ghostbtn"
                        text="Download"
                        textColor="text-neutrals-neutral-900"
                        bgColor="bg-neutrals-neutral-50"
                        borderColor="border-neutrals-neutral-100"
                        position="relative"
                        icon="assets/download.svg"
                      />
                    </div>
                  </div>
                </div>
                {/* Card 3 */}
                <div className="w-[400px] shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-3xs bg-white border-neutrals-neutral-100 border-solid border-[1px] box-border flex flex-col items-start justify-start">
                  <div className="self-stretch flex flex-row items-start justify-between p-6 gap-0">
                    <div className="flex flex-col items-start justify-start gap-2.5">
                      <img
                        className="w-10 relative h-10"
                        alt=""
                        src="assets/pdf.svg"
                      />
                      <div className="relative font-semibold">
                        Acknowledgment.pdf
                      </div>
                      <div className="relative text-neutrals-neutral-300">
                        2.5MB
                      </div>
                    </div>
                    <div className="relative text-neutrals-neutral-300">
                      29/01/24
                    </div>
                  </div>
                  <div className="self-stretch border-neutrals-neutral-100 border-solid border-t-[1px] flex flex-col items-end justify-start py-4 px-6 text-sm">
                    <div className="flex flex-row items-start justify-end gap-[10px]">
                      <CTAs
                        type="Ghostbtn"
                        text="Delete"
                        textColor="text-neutrals-neutral-900"
                        bgColor="bg-neutrals-neutral-50"
                        borderColor="border-neutrals-neutral-100"
                        position="relative"
                        icon="assets/delete.svg"
                        onClick={openFileDeletion1}
                      />

                      <CTAs
                        type="Ghostbtn"
                        text="Download"
                        textColor="text-neutrals-neutral-900"
                        bgColor="bg-neutrals-neutral-50"
                        borderColor="border-neutrals-neutral-100"
                        position="relative"
                        icon="assets/download.svg"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Upload document */}
            <div className="self-stretch flex flex-row items-start justify-start gap-[106px] text-sm">
              <div className="w-full flex flex-col flex-wrap items-start justify-start gap-2.5">
                <Upload width="612px" />
              </div>
              <div className="shadow-[0px_10px_60px_rgba(0,_0,_0,_0.1)] rounded-3xs bg-primary-primary-50 border-neutrals-neutral-100 border-solid border-[1px] flex flex-row items-start justify-start p-1.5">
                <img
                  className="w-[518px] relative rounded-3xs h-[599px] object-cover"
                  alt=""
                  src="image 4.png"
                />
              </div>
            </div>
            <Footer />
          </div>
        </div>
      </div>
      {isInstructionDeletionOpen && (
        <PortalPopup
          overlayColor="rgba(113, 113, 113, 0.3)"
          placement="Centered"
          onOutsideClick={closeInstructionDeletion}
        >
          <InstructionDeletion onClose={closeInstructionDeletion} />
        </PortalPopup>
      )}
      {isFileDeletionOpen && (
        <PortalPopup
          overlayColor="rgba(113, 113, 113, 0.3)"
          placement="Centered"
          onOutsideClick={closeFileDeletion}
        >
          <FileDeletion onClose={closeFileDeletion} />
        </PortalPopup>
      )}
      {isFileDeletion1Open && (
        <PortalPopup
          overlayColor="rgba(113, 113, 113, 0.3)"
          placement="Centered"
          onOutsideClick={closeFileDeletion1}
        >
          <FileDeletion onClose={closeFileDeletion1} />
        </PortalPopup>
      )}
      {isFileDeletion2Open && (
        <PortalPopup
          overlayColor="rgba(113, 113, 113, 0.3)"
          placement="Centered"
          onOutsideClick={closeFileDeletion2}
        >
          <FileDeletion onClose={closeFileDeletion2} />
        </PortalPopup>
      )}
      {isFileDeletion3Open && (
        <PortalPopup
          overlayColor="rgba(113, 113, 113, 0.3)"
          placement="Centered"
          onOutsideClick={closeFileDeletion3}
        >
          <FileDeletion onClose={closeFileDeletion3} />
        </PortalPopup>
      )}
      {isLogoutConfirmationOpen && (
        <PortalPopup
          overlayColor="rgba(113, 113, 113, 0.3)"
          placement="Centered"
          onOutsideClick={closeLogoutConfirmation}
        >
          <LogoutConfirmation onClose={closeLogoutConfirmation} />
        </PortalPopup>
      )}
    </>
  );
};

export default CDI_3;
